<div class="sip-wrapper" inViewport (inViewportAction)="checkVisibility($event)">
  <div class="header">
    <div class="desc">
      <div class="title">Save A Life Every Month!</div>
      <div class="sub-title">Join our monthly giving program today to gain tax benefits, earn rewards and allocate your funds.</div>
    </div>
    <div class="image">
      <img loading="lazy" [attr.data-src]="'/assets/images/sip-by-ketto.png'" appImgFallback [default]="vars.defaultImg" alt="ketto">
    </div>
  </div>

  <div class="how-works">
    <div class="title">How it works?</div>
    <div class="dashed-line"></div>
    <div class="journey">
      <div class="first">
        <div class="image">
          <img class="boundry" loading="lazy" [attr.data-src]="'/assets/images/sip-story/sip-story-circle.png'" appImgFallback [default]="vars.defaultImg" alt="ketto">
          <img class="avatar" loading="lazy" [attr.data-src]="vars.fundraiser?.theater?.cdn_path || vars.fundraiser?.leaderboard?.cdn_path" appImgFallback [default]="vars.defaultImg" alt="ketto">
        </div>
        <div class="text">First Contribution to <strong>{{vars.beneficiary?.full_name?.trim()}}</strong> </div>
      </div>
      <div class="second">
        <div class="image">
          <img loading="lazy" [attr.data-src]="'/assets/images/sip-story/sip-story-04.png'" appImgFallback [default]="vars.defaultImg" alt="ketto">
        </div>
        <div class="text">Next Contribution in <strong>{{currentDate | customDate:'format':'MMMM':'month':'1'}}</strong></div>
      </div>
      <div class="third">
        <div class="image">
          <img loading="lazy" [attr.data-src]="'/assets/images/sip-story/sip-story-03.png'" appImgFallback [default]="vars.defaultImg" alt="ketto">
        </div>
        <div class="text">Next Contribution in <strong>{{currentDate | customDate:'format':'MMMM':'month':'2'}}</strong></div>
      </div>
      <div class="last">
        <div class="image">
          <img *ngIf="!vars.isMobile" loading="lazy" [attr.data-src]="'/assets/images/sip-story/sip-story-02.png'" appImgFallback [default]="vars.defaultImg" alt="ketto">
          <img *ngIf="vars.isMobile" loading="lazy" [attr.data-src]="'/assets/images/sip-story/sip-story-01.png'" appImgFallback [default]="vars.defaultImg" alt="ketto">
        </div>
        <div class="text">Following contributions to <strong>other patients like {{vars.beneficiary?.full_name?.trim()}}</strong></div>
      </div>
    </div>
  </div>

  <div *ngIf="vars.isMobile" class="btn">
    <button (click)="donatenow()" mat-button>Let’s do it <em class="material-icons">arrow_forward_ios</em></button>
  </div>
</div>
